import React from 'react';
import { 
  Sword, 
  Zap, 
  Target, 
  Crosshair, 
  Shield, 
  Bomb,
  LayoutGrid
} from 'lucide-react';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange, loading }) => {
  const getCategoryIcon = (categoryId) => {
    const iconMap = {
      'all': LayoutGrid,
      'knives': Sword,
      'pistols': Zap,
      'rifles': Target,
      'sniper': Crosshair,
      'smgs': Shield,
      'shotguns': Bomb,
      'machine guns': Target,
      'gloves': Shield,
      'other': LayoutGrid
    };
    return iconMap[categoryId.toLowerCase()] || LayoutGrid;
  };

  if (loading) {
    return (
      <div className="flex space-x-2 overflow-x-auto pb-2">
        {[...Array(7)].map((_, i) => (
          <div key={i} className="flex-shrink-0 w-24 h-12 bg-gray-700 rounded-lg animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex space-x-2 overflow-x-auto pb-2 scrollbar-hide">
      {categories.map((category) => {
        const Icon = getCategoryIcon(category.id);
        const isActive = activeCategory === category.id;
        
        return (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`flex-shrink-0 flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
              isActive
                ? 'bg-primary-600 text-white shadow-lg transform scale-105'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600 hover:text-white'
            }`}
          >
            <Icon className="h-4 w-4" />
            <span className="whitespace-nowrap">{category.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryFilter;
